<div class="pulse-circle">
  <div class="pulse-circle__inner"></div>
</div>
